import { lazy } from 'react';
import { CommentEditFilled } from '@fluentui/react-icons';
import { FeatureDefinition } from '../../types/feature.types';

export const toolsDefinition: FeatureDefinition = {
  id: 'tools',
  name: 'Tools',
  // Annotating is what this tab is mostly used for — a comment bubble with a
  // pencil says that; the generic wrench said nothing.
  icon: CommentEditFilled,
  component: lazy(() => import('./Tools')),
  order: 20, // AI Buddy (10) · Tools (20) · Config (100)
  enabled: true,
};
